/**
 * Dev Tool Hooks
 * Export all dev tool related hooks from a single location
 */

import DevToolPanel from './DevToolPanel';
import ResizeHandle from './ResizeHandle';
import KeyboardShortcuts from './KeyboardShortcuts';
import DevToolFlash from './DevToolFlash';

export {
  DevToolPanel,
  ResizeHandle,
  KeyboardShortcuts,
  DevToolFlash
};

// Export as a single object for easy spreading into hooks config
export default {
  DevToolPanel,
  ResizeHandle,
  KeyboardShortcuts,
  DevToolFlash
};